import { HttpEvent, HttpEventType, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { from, map, Observable, switchMap } from 'rxjs';
import { AuthFields } from 'src/app/shared/models/auth-fields';

import { environment } from 'src/environments/environment';
import { AuthService } from '../auth/services/auth.service';

@Injectable()
export class HttpRequestInterceptor implements HttpInterceptor {
	constructor(private authService: AuthService) {}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const operationName = req.body && req.body.operationName ? req.body.operationName : '';
		const isRefresh = operationName.includes('RefreshToken');
		// useApiKey is for when the operation requires that the loggedInUser on the server is the Agent instead of the Customer
		const useApiKey = operationName.includes('SendCustomerRequestStayInTouchEmail');
		return from(this.authService.getAuthFields(isRefresh)) // make sure we're always getting the latest token
			.pipe(
				switchMap(authFields => {
					const token = this.getToken(authFields, isRefresh, useApiKey);
					const clonedRequest = req.clone({
						headers: req.headers.set('Authorization', 'Bearer ' + token),
					});
					return next.handle(clonedRequest).pipe(
						map(event => {
							let unauthenticated = false;

							if (event.type === HttpEventType.Response && event.status === 200 && event.body && Array.isArray(event.body.errors)) {
								const errors = event.body.errors as any[];

								unauthenticated = errors.some(e => e.extensions && e.extensions.code === 'UNAUTHENTICATED');
							}

							if (unauthenticated) {
								this.authService.logout();
							}

							return event;
						}),
					);
				}),
			);
	}

	private getToken(authFields: AuthFields, isRefresh: boolean, useApiKey: boolean): string {
		if (!authFields?.token || useApiKey) {
			return environment.apiKey;
		}
		return isRefresh ? authFields.refreshToken : authFields.token;
	}
}
